import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Modal, Select, TextField, Typography } from "@mui/material";
import { loadavg } from "os";
import React, { useEffect, useState } from "react";
import { Auth } from "src/app/models/auth";
import { useAppDispatch, useAppSelector } from "src/app/react/hooks/redux";
import { CollaboratorRequest } from "src/app/react/models/collaborator/collaborator-request.model";
import { getCostCenters, getUnits, getDepartments } from "src/app/react/redux/assignor/actions";
import { ModalBody } from "./style";


interface CollaboratorsFilterModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    onHandleFilter: (collaboratorsFilter: CollaboratorRequest) => void;
}

export default function CollaboratorsFilterModal({ isOpen, onRequestClose, onHandleFilter }: CollaboratorsFilterModalProps) {

    const currentUser: Auth = JSON.parse(localStorage.getItem('currentUser'));

    const dispatch = useAppDispatch();
    const { costCenters, units, departments, loading } = useAppSelector(state => state.assignor);

    const [ name, setName ] = useState<string>();
    const [ document, setDocument ] = useState<string>();
    const [ register, setRegister ] = useState<string>();
    const [ selectedCostCenter, setCostCenter ] = useState<string>(null);
    const [ selectedUnit, setUnit ] = useState<string>(null);
    const [ selectedDepartment, setDepartment ] = useState<string>(null);    

    useEffect(() => {
        dispatch(getCostCenters(currentUser.token.assignorGuid));
        dispatch(getUnits(currentUser.token.assignorGuid));
        dispatch(getDepartments(currentUser.token.assignorGuid));
    },[])

    const handleFilter = () => {
        const collaboratorsFilter: CollaboratorRequest = {
            name: name,
            document,
            register,
            costCenter: selectedCostCenter,
            unity: selectedUnit,
            departament: selectedDepartment
        };

        console.log(collaboratorsFilter)

        onHandleFilter(collaboratorsFilter);
    }

   
    return (
        <Modal
            open={isOpen}
            onClose={onRequestClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <ModalBody>
                <Typography id="modal-modal-title" className="text-center" variant="h6" component="h2">
                    Aplicar filtro
                </Typography>
                { loading && 
                    <Box>
                        <Typography id="modal-modal-loading" className="text-center" variant="subtitle1">
                            Carregando filtros
                        </Typography>
                    </Box>
                }
                { !loading &&
                    <Box>
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} className="p-5">
                            <Grid item xs={2} sm={4} md={4} key="name-item">
                                <TextField
                                    id="std-name-input"
                                    label="Nome"
                                    type="text"
                                    variant="standard"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={2} sm={4} md={4} key="document-item">
                                <TextField
                                    id="std-document-input"
                                    label="CPF"
                                    type="text"
                                    variant="standard"
                                    value={document}
                                    onChange={(e) => setDocument(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={2} sm={4} md={4} key="register-item">
                                <TextField
                                    id="std-register-input"
                                    label="Matrícula"
                                    type="text"
                                    variant="standard"
                                    value={register}
                                    onChange={(e) => setRegister(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={2} sm={4} md={4} key="costcenter-item">
                                <FormControl  sx={{ minWidth: 180 }}>
                                    <InputLabel id="select-std-costcenter-lbl">Centro de Custo</InputLabel>
                                    <Select
                                        labelId="select-std-costcenter-lbl"
                                        id="select-std-costcenter"
                                        value={selectedCostCenter}
                                        onChange={(e) => setCostCenter(e.target.value)}
                                        label="Centro de Custo"
                                        >
                                        <MenuItem value="">
                                            <em>Nenhum</em>
                                        </MenuItem>
                                        { costCenters.map(item => (
                                            <MenuItem value={item.name}>{item.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} sm={4} md={4} key="unit-item">
                                <FormControl  sx={{ minWidth: 180 }}>
                                    <InputLabel id="select-std-unity-lbl">Unidade</InputLabel>
                                    <Select
                                        labelId="select-std-unity-lbl"
                                        id="select-std-unity"
                                        value={selectedUnit}
                                        onChange={(e) => setUnit(e.target.value)}
                                        label="Unidade"
                                        >
                                        <MenuItem value="">
                                            <em>Nenhum</em>
                                        </MenuItem>
                                        { units.map(item => (
                                            <MenuItem value={item.name}>{item.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} sm={4} md={4} key="department-item">
                                <FormControl  sx={{ minWidth: 180 }}>
                                    <InputLabel id="select-std-department-lbl">Departamento</InputLabel>
                                    <Select
                                        labelId="select-std-department-lbl"
                                        id="select-std-department"
                                        value={selectedDepartment}
                                        onChange={(e) => setDepartment(e.target.value)}
                                        label="Departamento"
                                        >
                                        <MenuItem value="">
                                            <em>Nenhum</em>
                                        </MenuItem>
                                        { departments.map(item => (
                                            <MenuItem value={item.name}>{item.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center">
                            <Button 
                                variant="contained"
                                onClick={handleFilter}
                            >
                                Aplicar
                            </Button>
                        </Grid>
                    </Box>
                }
            </ModalBody>
        </Modal>
    )
}